import Icon from '../components/Icon.vue'

Icon.register({
  'greater-than-equal': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M55.2 107.7L230.8 175.8 55.3 243.8C37 249.9 27.5 268.2 34.1 284.8L46.2 314.9C52.9 331.5 73.2 340.1 91.6 334.1L393 214.2C406.8 209.7 416 197.6 416 184V168.1C416 154.5 406.8 142.4 393 137.9L91.3 17.9C73 11.9 52.8 20.4 46.1 37L34.1 66.9C27.5 83.4 36.9 101.7 55.2 107.7zM424 400H24C10.8 400 0 410.7 0 424V472C0 485.3 10.8 496 24 496H424C437.3 496 448 485.3 448 472V424C448 410.7 437.3 400 424 400z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/greater-than-equal.js
// module id = P5LR
// module chunks = 144